<scitis-app-global-page-header [pageTitle]="'Functions'">
</scitis-app-global-page-header>


@if (isCPOneGateway) {
  <div class="row">
    <!--UPDATE GATEWAY SOFTWARE-->
    <div class="col-12 col-lg-4 mb-3">
      <div class="card card-default h-100">
        <div class="card-header h5">
          <div class="row">
            <div class="col">
              <span translate>Update gateway software</span>
            </div>
            <div class="col-auto">
              @if (showUpdateGatewaySoftware()) {
                <em
                class="fa-solid fa-spinner fa-spin"></em>
              }
            </div>
          </div>
        </div>
        <div class="card-body d-flex flex-column justify-content-end">
          @if (gateway.updateStatus?.state === updateState.ERROR) {
            <div class="alert alert-danger">
              <p class="mb-0" translate>
                An Error occurred. Please contact the gateway admin or try again.
              </p>
            </div>
          }
          <button (click)="onCPOneSoftwareUpdate()"
            [disabled]="(!superOrTechAdminRole) || (gateway.updateStatus && (gateway.updateStatus.state===updateState.REQUESTED || gateway.updateStatus.state===updateState.PROGRESS || gateway.updateStatus.state === updateState.PENDING))"
            [ngClass]="'btn-primary'"
            class="btn btn-block">
            <span [innerText]="getUpdateGatewayButtonText(gateway.updateStatus)" class="ng-scope" translate></span>
          </button>
        </div>
      </div>
    </div>
    <!--UPLOAD CONFIGURATION-->
    <div class="col-12 col-lg-4 mb-3">
      <div class="card card-default h-100">
        <div class="card-header h5">
          <div class="row">
            <div class="col">
              <span translate>Upload configuration from gateway</span>
            </div>
            <div class="col-auto">
              @if (gateway.configUploadRequested) {
                <em class="fa-solid fa-spinner fa-spin"></em>
              }
            </div>
          </div>
        </div>
        <div class="card-body d-flex flex-column justify-content-end">
          <button (click)="onCPOneConfigurationUpload()"
            [disabled]="(!superOrTechAdminRole) || gateway.configUploadRequested"
            [ngClass]="'btn-primary'"
            class="btn btn-block">
            @if (!gateway.configUploadRequested) {
              <span class="ng-scope" translate>Upload</span>
            }
            @if (gateway.configUploadRequested) {
              <span class="ng-scope" translate>Upload in progress</span>
            }
          </button>
        </div>
      </div>
    </div>
    <!--DOWNLOAD CONFIGURATION-->
    <div class="col-12 col-lg-4 mb-3">
      <div class="card card-default h-100">
        <div class="card-header h5">
          <div class="row">
            <div class="col">
              <span translate>Download configuration to gateway</span>
            </div>
            <div class="col-auto">
              @if (gateway.configDownloadRequested) {
                <em class="fa-solid fa-spinner fa-spin"></em>
              }
            </div>
          </div>
        </div>
        <div class="card-body d-flex flex-column justify-content-end">
          <button (click)="onCPOneConfigurationDownload()"
            [disabled]="(!superOrTechAdminRole) || gateway.configDownloadRequested || !userDetailsLoaded"
            [ngClass]="'btn-primary'"
            class="btn btn-block">
            @if (!gateway.configDownloadRequested) {
              <span class="ng-scope" translate>Download</span>
            }
            @if (gateway.configDownloadRequested) {
              <span class="ng-scope" translate>Download in progress</span>
            }
          </button>
        </div>
      </div>
    </div>
  </div>
}
@if (isCPOneGateway) {
  <div class="row">
    <!--REBOOT GATEWAY-->
    <div class="col-12 col-lg-4 mb-3">
      <div class="card card-default h-100">
        <div class="card-header h5">
          <div class="row">
            <div class="col">
              <span translate>Reboot gateway</span>
            </div>
            <div class="col-auto">
              @if (gateway.rebootRequest) {
                <em class="fa-solid fa-spinner fa-spin"></em>
              }
            </div>
          </div>
        </div>
        <div class="card-body d-flex flex-column justify-content-end">
          @if (gateway.rebootStatus?.state === rebootState.ERROR) {
            <div class="alert alert-danger">
              <p class="mb-0">
                An Error occurred. Please contact the gateway admin or try again.
              </p>
            </div>
          }
          <button (click)="onCPOneReboot()"
            [disabled]="(!superOrTechAdminRole) || gateway.rebootRequest"
            [ngClass]="'btn-primary'"
            class="btn btn-block">
            <span [innerText]="getRebootButtonText(gateway)" class="ng-scope" translate></span>
          </button>
        </div>
      </div>
    </div>
    <!--DOWNLOAD LOGS-->
    <div class="col-12 col-lg-4 mb-3">
      <div class="card card-default h-100">
        <div class="card-header h5">
          <div class="row">
            <div class="col">
              <span translate>Request logs</span>
            </div>
            <div class="col-auto">
              @if (gateway.logUploadRequested) {
                <em class="fa-solid fa-spinner fa-spin"></em>
              }
            </div>
          </div>
        </div>
        <div class="card-body d-flex flex-column justify-content-end">
          @if (gateway.logUploadStatus?.state === logUploadState.ERROR) {
            <div class="alert alert-danger">
              <p class="mb-0">
                An Error occurred. Please contact the gateway admin or try again.
              </p>
            </div>
          }
          <button (click)="onCPOneLogRequest()"
            [disabled]="(!superOrTechAdminRole) || gateway.logUploadRequested"
            [ngClass]="'btn-primary'"
            class="btn btn-block">
            <span [innerText]="getRequestLogsButtonText(gateway)" class="ng-scope" translate></span>
          </button>
        </div>
      </div>
    </div>
  </div>
}
@if (isArgosGateway||isGenericGateway) {
  <div class="row">
    <!--RESET GATEWAY VALUES-->
    <div class="col-12 col-lg-4 mb-3">
      <div class="card card-default h-100">
        <div class="card-header h5">
          <div class="row">
            <div class="col">
              <span translate>Gateway communication</span>
            </div>
          </div>
        </div>
        <div class="card-body d-flex flex-column justify-content-end">
          <button (click)="onGatewayCommunication()"
            [disabled]="!superOrTechAdminRole"
            [ngClass]="'btn-primary'"
            class="btn btn-block">
            <span [innerHtml]="'Send command or configuration'|translate" class="ng-scope"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
}

